
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","viewBox":"0 0 52.917 52.917","xmlns":"http://www.w3.org/2000/svg","stroke":"#000","fill":"none","stroke-width":"5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.772 11.906L20.014 26.458 33.772 41.01"}})])
          )
        }
      }
    